/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\Carrier\CarrierSerice.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday July 26th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 25th September 2023 10:17:24
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { CarrierToSend } from "Type/carrier.type";
import { buildAxiosHeader } from "Utils/Request.utils";
import Axios from "axios";

export default class CarrierService {
    static async addCarrier(myIntels: CarrierToSend) {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.CARRIER}`;
        const myCarrier = await Axios.post(url, myIntels, buildAxiosHeader());
        return myCarrier;
    }
    static async getCarrier() {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.CARRIER}`;
        const myCarrier = await Axios.get(url, buildAxiosHeader());
        return myCarrier.data;
    }
    static async getCarriersInfo() {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.CARRIER}/count`;
        const myCarrier = await Axios.get(url, buildAxiosHeader());
        return myCarrier.data;
    }
}
